import { z } from 'zod';
import { BullMQPayloadBaseSchema } from './base.js';

/**
 * Payload passed to `queue.add('generate-case-summary', ...)` by
 * synthesis_batch_processor.scheduleCaseSummaryGeneration().
 *
 * The BullMQ jobId is deterministic (`generate-summary-{caseId}`) and is
 * supplied via `opts.jobId` — NOT via `data`. The enqueue call only sends
 * `{ caseId, cabinetId, requestId }`, so `jobId` is overridden to optional
 * here (the base makes it required because synthesis DOES put jobId in
 * data).
 */
export const GenerateCaseSummaryPayloadSchema = BullMQPayloadBaseSchema
  .extend({
    jobId: z.string().optional(),
    caseId: z.string().uuid(),
    cabinetId: z.string().uuid(),
  })
  .passthrough();
export type GenerateCaseSummaryPayload = z.infer<typeof GenerateCaseSummaryPayloadSchema>;

// NOTE: no `JobDataSchema` for this family — the processor uses a single Zod
// parse of the BullMQ payload. There is no `job:{jobId}` Redis record to load
// because `scheduleCaseSummaryGeneration` only calls `queue.add` (never
// `jobManager.createJob`). Re-introduce a JobData schema if a future caller
// starts writing Redis state for this job.
